import * as React from 'react';
import {styledDiv} from '@packages/utilities/styled';
import {oneLineText} from '../constants/Styles';
import type {CSSProperties} from '@packages/utilities/css-properties-type';

const CounterContainer = styledDiv(
  ({theme, style}) => ({
    background: theme.colors.successAccent,
    paddingRight: theme.gutters.x4,
    paddingLeft: theme.gutters.x4,
    display: 'flex',
    minWidth: 16,
    maxWidth: 40,
    height: 16,
    borderRadius: 10,
    color: theme.counter.color,
    fontWeight: theme.typography.subheading.fontWeight,
    fontSize: theme.typography.finePrint.fontSize,
    justifyContent: 'center',
    alignSelf: 'center',
    ...oneLineText,
    ...style,
  }),
  {
    warning: ({theme}) => ({
      background: theme.colors.warningAlt,
    }),
    danger: ({theme}) => ({
      background: theme.colors.danger,
    }),
  }
);

const Counter = ({
  count,
  warning,
  danger,
  style,
}: {
  count: number;
  warning?: boolean;
  danger?: boolean;
  style?: CSSProperties;
}) => (
  <CounterContainer
    warning={warning}
    danger={danger}
    style={style}
    data-legacy-ds="Counter"
  >
    {count}
  </CounterContainer>
);

export default Counter;
